import React, { useState } from 'react'
import { Link } from "react-router-dom";
import Moment from "react-moment"
import { ExclamationIcon, PencilIcon, TrashIcon } from '@heroicons/react/outline';
import WmModals from '../../modals/Wm.Modals';
import { deleteEntityCertificate, getCertificateDetail } from '../../functions/certificatesAPI';
import { useMutation, useQueryClient, } from "react-query";
import Spinner from '../../Components/spinner/Spinner';


function EventCard({ eventData }) {
    const queryClient = useQueryClient()
    const { event_id, event_name, thumbnail, created_on, status } = eventData
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [eventDeleteData, setEventData] = useState({ eventId: '', eventName: '' })
    const handleDeleteModal = (id, eventName) => {
        setEventData({ eventId: id, eventName: eventName })
        setIsDeleteModalOpen(true)
    }
    const handleDelete = useMutation((eventId) => deleteEntityCertificate(eventId), {
        onError: (err, previousValue) => {
            queryClient.setQueryData('eventEntityList', previousValue)
        },
        onSuccess: () => {
            queryClient.invalidateQueries('eventEntityList')
            setIsDeleteModalOpen(false)
        }
    })
    return (
        <>
            <div className='shadow rounded-md px-2 transition ease-in-out duration-500 hover:shadow-md '>
                <Link to={`/i/institute/viewevents/${event_id}`} className=' no-underline'>
                    <div>
                        <div className='pt-3'>
                            <img src={thumbnail} alt={event_name} />
                        </div>
                        <div className='pt-3'>
                            <div >
                                <span className='block text-gray-700 font-semibold wordClamp-1'>{event_name}</span>
                                <span className='block text-gray-600 text-xs mb-1.5'><Moment fromNow>{created_on}</Moment></span>
                            </div>
                        </div>
                    </div>
                </Link>
                <div className='flex justify-between pb-3'>
                    <div>
                        {status === "1" ? <span className='text-xs manpro bg-green-200 text-green-700 inline-block px-4 py-0.5 rounded font-semibold'>Completed</span> : status === "2" ? <span className='text-xs manpro bg-red-200 text-red-700 inline-block px-4 py-0.5 rounded font-semibold'>Error while generating</span> : <span className='text-xs manpro bg-yellow-200 text-yellow-700 inline-block px-4 py-0.5 rounded font-semibold'>Processing</span>}
                    </div>
                    <div className='flex items-center space-x-2'>
                        <div className=' cursor-pointer' onClick={() => handleDeleteModal(event_id, event_name,)}>
                            <TrashIcon className='w-6 text-gray-500' />
                        </div>
                    </div>
                </div>
            </div>
            <WmModals show={isDeleteModalOpen} onHide={() => setIsDeleteModalOpen(false)} size="md" className="">
                <div className='px-10 py-4'>
                    <div>
                        <p className='text-center text-xl font-semibold text-gray-700 manpro'>Delete Event?</p>
                        <p className='text-center mb-0  text-gray-700 manpro'>Are you sure you want to delete <span className='font-semibold'>{eventDeleteData.eventName}</span>?</p>
                        <p className='text-center mb-0 text-gray-700 manpro'>You can't undo this action.</p>
                        <div className=' bg-red-100 rounded border-l-2 border-red-700 my-10'>
                            <div className='flex space-x-3 p-4'>
                                <div>
                                    <ExclamationIcon className='w-6 text-red-600' />
                                </div>
                                <div>
                                    <p className='manpro text-red-800 mb-0 font-semibold'>Warning</p>
                                    <p className='manpro text-red-700 mb-0 text-sm'>By deleting this certifcate all other certificates connected to this will be deleted.</p>
                                </div>
                            </div>
                        </div>
                        <div className='text-center space-x-3 flex justify-center'>
                            <button className='px-4 py-1 bg-gray-700 text-white  rounded-full' onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
                            {handleDelete.isLoading ? <div className='relative flex items-center justify-center'><Spinner className="" width={20} height={20} /></div> : <button className='px-4 py-1 bg-red-500 rounded-full text-white' onClick={(e) => { handleDelete.mutate(eventDeleteData.eventId) }}>Delete event</button>}
                        </div>
                    </div>
                </div>
            </WmModals>
        </>
    )
}

export default EventCard